import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    authToken: "",
}

const keySlice = createSlice({
    name: 'key',
    initialState,
    reducers: {
        updateAuthToken: (state, action) => {
            state.authToken = action.payload
        }
    },
})

export const {updateAuthToken} = keySlice.actions

export default keySlice.reducer;